import React from 'react';
import { motion } from 'framer-motion';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Loader2 } from 'lucide-react';

const StatCard = ({ title, value, icon, color, description, isLoading }) => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.5 }}
  >
    <Card className="bg-slate-800/70 border-slate-700 shadow-xl hover:shadow-blue-500/30 transition-shadow duration-300">
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium text-slate-300">{title}</CardTitle>
        {isLoading ? <Loader2 className="h-5 w-5 text-slate-400 animate-spin" /> : React.createElement(icon, { className: `h-5 w-5 ${color}` })}
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <div className="h-9 w-1/2 bg-slate-700 animate-pulse rounded-md"></div>
        ) : (
          <div className="text-3xl font-bold text-white">{value}</div>
        )}
        {description && !isLoading && <p className="text-xs text-slate-400 pt-1">{description}</p>}
      </CardContent>
    </Card>
  </motion.div>
);

export default StatCard;